import Button from 'components/shared/Button/Button';

const Footer = ({ onCancel, onApply, isValid }) => {
  return (
    <div className="flex h-[56px] items-center justify-end gap-3 border-0 border-t border-solid border-neutral-200 px-4">
      <Button text="Cancel" variant="tertiary" size="small" onClick={onCancel} />
      <Button text="Apply" variant="primary" size="small" onClick={onApply} isDisabled={!isValid} />
    </div>
  );
};

export default Footer;
